import { render, staticRenderFns } from "./ThinPie.vue?vue&type=template&id=eed0d0ce"
import script from "./ThinPie.vue?vue&type=script&lang=js"
export * from "./ThinPie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports